module.exports = { da: {"core": {
 "components": {
 "module-access-error": {
 "module-access-error-i18n": {
errorMessage: "Du har ikke adgang til modulet."
}
}
}
},
"domains": {
 "application": {
 "components": {
 "backend-access": {
 "backend-access-i18n": {
message: "Det er ikke lykkedes at forbinde til applikationsserveren. Dette vil ofte skyldes, at der ikke er opsat Microsoft konto på din Advosys konto. Log ind i Advosys med din Microsoft konto for at aktivere denne."
}
},
"main-layout": {
 "components": {
 "about-dialog": {
 "about-dialog-i18n": {
versionLabel: "Version",
appServerVersionLabel: "App Server Version",
copyright: "© {{ year }} Epona A/S",
clearCache: "Nulstil Advosys cache"
}
},
"error-handler-i18n": {
header: "Fejl"
},
"settings-dialog": {
 "settings-dialog-i18n": {
dialogHeader: "Indstillinger",
languageLabel: "Sprog",
languageDa: "Dansk",
languageEn: "Engelsk"
}
}
},
"main-layout-i18n": {
header: "Unik Advosys",
footer: "© {{aar}}",
signOut: "Log af",
settings: "Indstillinger",
support: "Support",
about: "Om Advosys"
}
}
},
"pages": {
 "home-page": {
 "home-page-i18n": {
pageTitle: "Advosys",
message: "Vælg noget i menuen til venstre."
}
}
}
},
"authentication": {
 "components": {
 "login-gate": {
 "login-gate-i18n": {
ikkeLoggetInd: "Du er ikke logget ind.",
loginSpinnerText: "Logger ind..."
}
}
}
},
"dynamic-invoice": {
 "pages": {
 "dynamic-invoice-page": {
 "components": {
 "dynamic-invoice-dialog": {
 "components": {
 "invoice-text": {
 "invoice-text-i18n": {
noteLabel: "Notat",
feeStatementLabel: "Fakturatekst",
invoiceRegardingLabel: "Faktura vedrørende"
}
},
"main-information": {
 "main-information-i18n": {
counterPartyIdLabel: "Fakturamodtager",
contactIdLabel: "Faktura til kontaktperson",
contactIdNoContactPlaceholder: "Der findes ingen kontaktpersoner",
feeLabel: "Salær",
recipientChangedConfirmationHeader: "Fakturamodtager ændret",
recipientChangedConfirmationMessage: "Du har ændret fakturamodtager. Derfor fjernes tilknyttede finansposter, og evt. finansposter med samme tilsvar stamnr. som den valgte fakturamodtager tilknyttes i stedet.",
recipientChangedConfirmationMessageNote: "Denne ændring kan kun fortrydes ved at ændre modtageren tilbage igen.",
approverFlowLabel: "Godkendelsesflow",
currentApproverFlowCommentLabel: "Aktuel kommentar",
economyHeader: "Økonomi",
billableAmountLabel: "Debiterbart beløb",
totalMatterLedgerEntriesLabel: "Saldo finansposter",
previouslyInvoicedAmountLabel: "Tidligere faktureret tid",
employeeHeader: "Medarbejdere",
liableLawyerLabel: "Ansvarlig jurist",
lawyerLabel: "Jurist",
attorneyLabel: "Fuldmægtig",
secretaryLabel: "Sekretær",
clientLeadLawyerLabel: "Klient ansvarlig jurist"
}
},
"matter-ledger-entries": {
 "matter-ledger-entries-i18n": {
columnDate: "Dato",
columnText: "Tekst",
columnAmount: "Beløb",
listHeader: "Finansposter"
}
},
"time-track-entries": {
 "time-track-entries-i18n": {
columnEmployee: "Medarbejder",
billableAmountMinutes: "Debiterbar tid",
columnActivityDescription: "Notat",
columnBillableAmount: "Beløb",
columnDate: "Dato",
listHeader: "Time-/sagsposter"
}
}
},
"dynamic-invoice-dialog-i18n": {
dialogHeaderStart: "Sag {{ matterId }}",
dialogHeaderEnd: "Faktura godkendelse",
previewButton: "Preview",
rejectButton: "Afvis faktura",
forwardButton: "Videregiv faktura",
saveChangesButton: "Gem ændringer",
approveButton: "Godkend faktura",
closeButton: "Luk",
functionHelpText: "Hjælp til funktioner",
dynamicInvoiceDialogHelp: "Detaljer"
}
},
"forward-dialog": {
 "forward-dialog-i18n": {
dialogHeader: "Videregiv faktura",
employeeLabel: "Medarbejder",
commentLabel: "Kommentar",
submitButtonText: "Videregiv"
}
},
"preview-dialog": {
 "preview-dialog-i18n": {
dialogHeader: "Faktura preview"
}
},
"reject-dialog": {
 "reject-dialog-i18n": {
dialogHeader: "Afvis faktura",
buttonSubmitText: "OK",
reason: "Kommentar"
}
}
},
"dynamic-invoice-page-i18n": {
pageTitle: "Godkend fakturaforslag",
buttonApprove: "Godkend faktura",
buttonReject: "Afvis faktura",
buttonForward: "Videregiv faktura",
buttonPreview: "Preview",
buttonRefreshToolTip: "Opdater",
columnMatterId: "Sagsnr.",
columnRecipientName: "Fakturamodtager",
columnContactName: "Faktura til kontaktperson",
columnInvoiceRegarding: "Faktura vedrørende",
columnFeeStatement: "Fakturatekst",
columnFee: "Salær",
columnBillableAmount: "Debiterbart beløb",
columnnTotalMatterLedgerEntries: "Finansposter",
columnApproverFlow: "Godkendelsesflow",
columnCurrentApproverFlowComment: "Aktuel kommentar",
columnLiableLawyer: "Sag ansvarlig jurist",
columnClientLeadLawyer: "Klient ansvarlig jurist",
columnLawyer: "Jurist",
columnAttorney: "Fuldmægtig",
columnMatterType: "Sagstype",
functionHelpText: "Hjælp til funktioner",
dynamicInvoicePageHelp: "Web godkendelse",
deleteButton: "Slet",
deleteConfirmationMessageSingular: "Du har valgt en faktura til sletning. Ønsker du at fortsætte?",
deleteConfirmationMessagePlural: "Du har valgt {{ count }} fakturaer til sletning. Ønsker du at fortsætte?"
}
}
}
}
},
"use-pages-i18n": {
invoice: "Fakturering",
dynamicInvoiceList: "Godkend fakturaforslag"
}
}, en: {"core": {
 "components": {
 "module-access-error": {
 "module-access-error-i18n": {
errorMessage: "You do not have access to this module."
}
}
}
},
"domains": {
 "application": {
 "components": {
 "backend-access": {
 "backend-access-i18n": {
message: "Connection to the application server failed. This is mainly because no Microsoft account has been set up on your Advosys account. Log in to Advosys with your Microsoft Account to activate it."
}
},
"main-layout": {
 "components": {
 "about-dialog": {
 "about-dialog-i18n": {
versionLabel: "Version",
appServerVersionLabel: "App Server Version",
copyright: "© {{ year }} Epona A/S",
clearCache: "Clear Advosys cache"
}
},
"error-handler-i18n": {
header: "Error"
},
"settings-dialog": {
 "settings-dialog-i18n": {
dialogHeader: "Settings",
languageLabel: "Language",
languageDa: "Danish",
languageEn: "English"
}
}
},
"main-layout-i18n": {
header: "Unik Advosys",
footer: "© {{aar}}",
signOut: "Sign out",
settings: "Settings",
support: "Support",
about: "About Advosys"
}
}
},
"pages": {
 "home-page": {
 "home-page-i18n": {
pageTitle: "Unik Advosys",
message: "Make a selection in the menu to the left."
}
}
}
},
"authentication": {
 "components": {
 "login-gate": {
 "login-gate-i18n": {
ikkeLoggetInd: "You are not signed in.",
loginSpinnerText: "Signing in..."
}
}
}
},
"dynamic-invoice": {
 "pages": {
 "dynamic-invoice-page": {
 "components": {
 "dynamic-invoice-dialog": {
 "components": {
 "invoice-text": {
 "invoice-text-i18n": {
noteLabel: "Note",
feeStatementLabel: "Invoice text",
invoiceRegardingLabel: "Invoice regarding"
}
},
"main-information": {
 "main-information-i18n": {
counterPartyIdLabel: "Invoice recipient",
contactIdLabel: "Invoice for contact",
contactIdNoContactPlaceholder: "There are no contacts",
feeLabel: "Fee",
recipientChangedConfirmationHeader: "Invoice recipient changed",
recipientChangedConfirmationMessage: "You have changed the invoice recipient. Associated ledger entries will therefore be removed, and any ledger entries with the same counterparty number as the selected invoice recipient will be attached instead.",
recipientChangedConfirmationMessageNote: "This change can only be undone by changing the recipient back again.",
approverFlowLabel: "Approval flow",
currentApproverFlowCommentLabel: "Current comment",
economyHeader: "Economy",
billableAmountLabel: "Billable amount",
totalMatterLedgerEntriesLabel: "Balance ledger entries",
previouslyInvoicedAmountLabel: "Previously billed time",
employeeHeader: "Users",
liableLawyerLabel: "Liable lawyer",
lawyerLabel: "Lawyer",
attorneyLabel: "Attorney",
secretaryLabel: "Secretary",
clientLeadLawyerLabel: "Client liable lawyer"
}
},
"matter-ledger-entries": {
 "matter-ledger-entries-i18n": {
columnDate: "Date",
columnText: "Text",
columnAmount: "Amount",
listHeader: "General ledger entries"
}
},
"time-track-entries": {
 "time-track-entries-i18n": {
columnEmployee: "User",
billableAmountMinutes: "Billable time",
columnActivityDescription: "Note",
columnBillableAmount: "Amount",
columnDate: "Date",
listHeader: "Time tracking entries"
}
}
},
"dynamic-invoice-dialog-i18n": {
dialogHeaderStart: "Matter {{ matterId }}",
dialogHeaderEnd: "Invoice approval",
previewButton: "Preview",
rejectButton: "Reject invoice",
forwardButton: "Forward invoice",
saveChangesButton: "Save changes",
approveButton: "Approve invoice",
closeButton: "Close",
functionHelpText: "Help functions",
dynamicInvoiceDialogHelp: "Details"
}
},
"forward-dialog": {
 "forward-dialog-i18n": {
dialogHeader: "Forward invoice",
employeeLabel: "User",
commentLabel: "Comment",
submitButtonText: "Forward"
}
},
"preview-dialog": {
 "preview-dialog-i18n": {
dialogHeader: "Invoice preview"
}
},
"reject-dialog": {
 "reject-dialog-i18n": {
dialogHeader: "Reject invoice",
buttonSubmitText: "OK",
reason: "Comment"
}
}
},
"dynamic-invoice-page-i18n": {
pageTitle: "Approve invoice draft",
buttonApprove: "Approve invoice",
buttonReject: "Reject invoice",
buttonForward: "Forward invoice",
buttonPreview: "Preview",
buttonRefreshToolTip: "Refresh",
columnMatterId: "Matter no.",
columnRecipientName: "Invoice recipient",
columnContactName: "Invoice for contact",
columnInvoiceRegarding: "Invoice regarding",
columnFeeStatement: "Invoice text",
columnFee: "Fee",
columnBillableAmount: "Billable amount",
columnnTotalMatterLedgerEntries: "General ledger entries",
columnApproverFlow: "Approval flow",
columnCurrentApproverFlowComment: "Current comment",
columnLiableLawyer: "Matter liable lawyer",
columnClientLeadLawyer: "Client liable lawyer",
columnAttorney: "Attorney",
columnLawyer: "Lawyer",
columnMatterType: "Matter type",
functionHelpText: "Help functions",
dynamicInvoicePageHelp: "Invoice approval",
deleteButton: "Delete",
deleteConfirmationMessageSingular: "You have chosen to delete one invoice. Do you wish to continue?",
deleteConfirmationMessagePlural: "You have chosen to delete {{ count }} invoices. Do you wish to continue?"
}
}
}
}
},
"use-pages-i18n": {
invoice: "Invoice",
dynamicInvoiceList: "Approve prepared invoice"
}
}};
